import { render, staticRenderFns } from "./Vaga.vue?vue&type=template&id=7b6a4892"
import script from "./Vaga.vue?vue&type=script&lang=js"
export * from "./Vaga.vue?vue&type=script&lang=js"
import style0 from "./Vaga.vue?vue&type=style&index=0&id=7b6a4892&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports